// Portal ระดับองค์กร (หน้าที่เข้าผ่าน "จัดการองค์กร") มีบทบาทผู้ดูแลแบบเดียว: roleId 0 (SuperAdmin ของบริษัท)
// กับ 1 (Admin) แสดงเป็น "ผู้ดูแลระบบ" ($t('admin')) ตัวเดียวกัน. map ที่ frontend เท่านั้น — RoleId ใน DB และสิทธิ์
// backend ไม่เปลี่ยน (BAL เช็ค roleId 0 || 1 คู่กันอยู่แล้ว). หน้า SuperAdmin (Product Admin) ไม่ใช้ไฟล์นี้.

// roleId ที่ portal ใช้ให้ผู้ดูแลคนใหม่ (คำเชิญ / เพิ่มผู้ใช้)
export const PORTAL_ADMIN_ROLE_ID = 1;

const ROLE_LABEL_KEYS = { 2: 'generalUsers', 6: '_Operator' };

// InvitationBAL.GetRoleName ส่ง "Super Admin" (มีช่องว่าง) — เทียบแบบไม่สนช่องว่าง/ตัวพิมพ์
const ROLE_NAME_TO_ID = { superadmin: 0, admin: 1, user: 2, operator: 6 };

function toRoleId(roleId) {
  if (roleId === null || roleId === undefined || roleId === '') return null;
  const id = Number(roleId); // cookie ให้ '0', API ให้ 0
  return Number.isInteger(id) ? id : null;
}

export function isPortalAdminRole(roleId) {
  const id = toRoleId(roleId);
  return id === 0 || id === 1;
}

// roleId → i18n key | null (role ที่ portal ไม่รู้จัก)
export function portalRoleLabelKey(roleId) {
  if (isPortalAdminRole(roleId)) return 'admin';
  return ROLE_LABEL_KEYS[toRoleId(roleId)] || null;
}

// roleName จาก API ("Super Admin" / "Admin" / "User" / "Operator") → i18n key | null
export function portalRoleNameLabelKey(roleName) {
  const id = ROLE_NAME_TO_ID[String(roleName || '').replace(/\s/g, '').toLowerCase()];
  return id === undefined ? null : portalRoleLabelKey(id);
}
